import { Icon as BlueIcon } from '@blueprintjs/core';
import { Description } from '@pages/Asset/components/Resources/Resources.styles';
import { useRef } from 'react';
import { useOverflow } from './ResourceLink.hooks';
import {
  ActionButton,
  ResourceLabel,
  ResourceLinkWrap,
  Row,
} from './ResourceLink.style';

interface ResourceLinkProps {
  'data-for': string;

  // Generic props
  onStarClick: React.MouseEventHandler<HTMLButtonElement>;
  isFavorite: boolean;
  label: string;
  uri: string;
  sourceOrDesc: React.ReactNode;
  showSourceOrDesc: boolean;
  menu: React.ReactNode;
}
/**
 * Asset page resource link
 * Requires asset page context to be defined.
 *
 * menu:  ResourcesItemMenu or DocumentsMenu
 */
export function ResourceLink(props: ResourceLinkProps) {
  const {
    onStarClick,
    isFavorite,
    label,
    uri,
    sourceOrDesc,
    showSourceOrDesc,
    menu,
    'data-for': dFor,
  } = props;
  const aRef = useRef<HTMLAnchorElement>(null);
  const isOverflow = useOverflow(aRef, label);

  const tip = isOverflow ? label : '';

  return (
    <ResourceLinkWrap>
      <Row>
        <ActionButton onClick={onStarClick}>
          {isFavorite ? (
            <BlueIcon icon="star" color="#ffc979" />
          ) : (
            <BlueIcon icon="star-empty" color="#8F95B2" />
          )}
        </ActionButton>
        <ResourceLabel
          data-for={dFor}
          data-tip={tip}
          ref={aRef}
          href={uri}
          target="_blank"
        >
          {label}
        </ResourceLabel>

        {showSourceOrDesc && <Description>{sourceOrDesc}</Description>}
      </Row>
      {menu}
    </ResourceLinkWrap>
  );
}
